// extracted by mini-css-extract-plugin
module.exports = {"infoWrap":"base-info_infoWrap_3iqkP","height":"base-info_height_10JUz"};